module.exports = __webpack_public_path__ + "static/media/ar_flag.fa12f13b.svg";